import {
  afterNextRender,
  Component,
  ElementRef,
  HostListener,
  inject,
  Injector,
  signal,
  viewChild,
} from '@angular/core';

import { APP_WIDTH_OPTIONS, AppWidth, SettingsService } from '@Services';

/**
 * Gear button plus the settings panel it opens. Lives in the status bar next
 * to "Change role" and "Sign out". Currently holds one setting: the width the
 * app content is capped at.
 */
@Component({
  selector: 'app-settings-panel',
  imports: [],
  templateUrl: './settings-panel.component.html',
  styleUrl: './settings-panel.component.css',
})
export class SettingsPanelComponent {
  readonly widthOptions = APP_WIDTH_OPTIONS;
  readonly isOpen = signal(false);

  private readonly toggleButton = viewChild<ElementRef<HTMLButtonElement>>('toggleButton');
  private readonly closeButton = viewChild<ElementRef<HTMLButtonElement>>('closeButton');
  private readonly injector = inject(Injector);

  constructor(private _settingsService: SettingsService) {}

  get appWidth(): AppWidth {
    return this._settingsService.appWidth();
  }

  open(): void {
    this.isOpen.set(true);
    // Move focus into the panel once it exists. A setTimeout is too early:
    // Angular schedules the render on a later task than a zero-delay timer.
    afterNextRender(() => this.closeButton()?.nativeElement.focus(), { injector: this.injector });
  }

  close(): void {
    this.isOpen.set(false);
    this.toggleButton()?.nativeElement.focus();
  }

  selectWidth(width: AppWidth): void {
    this._settingsService.setAppWidth(width);
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.isOpen()) {
      this.close();
    }
  }
}
